/* eslint semi:0 */
/* eslint-disable camelcase */
import { memoizeFirstCall, } from '../../jsCore/utils/fn'
import { namespacedConsts, } from '../../jsCore/utils/object'
import { getApiEndpoints, } from '../../jsCore/application/api'
import { getLeaguesForFixtures, } from '../../jsCore/application/pageDataObject'
import { FETCH_REQUEST_ACTION_TYPE, } from '../../jsCore/application/sagas/fetchSaga'


export const SCHEDULE_ACTION_TYPES = namespacedConsts({
  CHANGE_LEAGUE: true,
  CHANGE_SCHEDULE_DATE: true,
  CHANGE_NUM_VISIBLE_ITEMS: true,
})

export const API_ENDPOINT_NAME = 'MATCHES'

export function changeNumVisbileItems(numItems){
  return (dispatch, getState) => dispatch({
    type: SCHEDULE_ACTION_TYPES.CHANGE_NUM_VISIBLE_ITEMS,
    state: {
      numItems,
    },
  })
}

export function fetchData(dataTransformer){
  const { matchesEndpoint: { url, endpointName, }, } =
    memoizeFirstCall('matchesEndpoint', getApiEndpoints, API_ENDPOINT_NAME)
  return (dispatch, getState) => dispatch({
    type: FETCH_REQUEST_ACTION_TYPE,
    payload: {
      url,
      endpointName,
      dataTransformer,
      additionalState: {
        IS_INITIALIZED: true,
      },
    },
  })
}

export function changeLeague(leagueName){
  const leagueId = getLeaguesForFixtures().find(
    league => league.name === leagueName
  ).id
  return (dispatch, getState) => dispatch({
    type: SCHEDULE_ACTION_TYPES.CHANGE_LEAGUE,
    state: {
      leagueId,
      leagueName,
      leagueChanged: true,
    },
  })
}

export function changeScheduleDate(newDate){
  return (dispatch, getState) => dispatch({
    type: SCHEDULE_ACTION_TYPES.CHANGE_SCHEDULE_DATE,
    state: {
      scheduleDate: newDate,
    },
  })
}

export const scheduleActions = {
  fetchData, changeLeague, changeScheduleDate, changeNumVisbileItems,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleActions.js